import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { GenericDropDownV3, SimpleListAdapter, TS_DropDown, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { findingViewTypes } from '@app/advisor-ui-shared';
import { ModuleFE_FindingView } from './ModuleFE_FindingView.js';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { ICONS } from '@app/styles';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
const Props_DropDown = {
    module: ModuleFE_FindingView,
    modules: [ModuleFE_FindingView],
    mapper: item => [item.label],
    placeholder: 'Choose a finding view',
    renderer: item => _jsxs(_Fragment, { children: [item.label, " "] })
};
export const DropDown_FindingView = GenericDropDownV3.prepare(Props_DropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_FindingView,
    itemRenderer: (item, onDelete, disabled) => {
        return !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsxs(_Fragment, { children: [!disabled && _jsx(ICONS.x.component, { onClick: onDelete }), " ", item.label] });
    },
    uiSelector: DropDown_FindingView.selectable,
});
export const MultiSelect_FindingView = TS_MultiSelect_V2.prepare(Props_MultiSelect);
const mandatoryProps_FindingViewType = {
    adapter: SimpleListAdapter([...findingViewTypes], item => _jsx(_Fragment, { children: item.item })),
    caret: DropDown_DefaultCaret,
    placeholder: 'Select Finding View Type',
};
export const DropDown_FindingViewType = TS_DropDown.prepare(mandatoryProps_FindingViewType);
//# sourceMappingURL=ui-components.js.map